import { useIntl } from "react-intl";
import { Field } from "react-final-form";
import { TextInput, SwitchInput } from "../../../common/fields";
import * as Validations from "../../../common/form/validator";

const RewardDetailsForm = ({ disabled = false, readOnly = false }) => {
  const intl = useIntl();

  return (
    <div className="grid">
      {/* Name Field */}
      <div className="col-12 md:col-6 lg:col-4">
        <Field
          name="name"
          component={TextInput}
          label={intl.formatMessage({ id: "name" })}
          required
          validate={Validations.composeValidators(
            Validations.required,
            Validations.maxLength(100)
          )}
          disabled={disabled}
          placeholder={intl.formatMessage({ id: "enter_reward_name" })}
        />
      </div>

      {/* Total Rewards Available (0 = No Limit) */}
      <div className="col-12 md:col-6 lg:col-4">
        <Field
          name="totalRewardsAvailable"
          component={TextInput}
          type="number"
          label={intl.formatMessage({ id: "total_rewards_available" })}
          placeholder={intl.formatMessage({
            id: "enter_total_rewards_available",
          })}
          disabled={disabled}
          parse={(value) => (value === "" ? 0 : value)}
          infoMessage="total_rewards_available_info"
        />
      </div>

      {/* Active Status Field */}
      <div className="col-12 md:col-6 lg:col-4">
        <Field
          name="isActive"
          component={SwitchInput}
          type="checkbox"
          label={intl.formatMessage({ id: "active" })}
          disabled={disabled}
        />
      </div>

      {/* Points value removed (no longer applicable) */}
    </div>
  );
};

export default RewardDetailsForm;
